module.exports = {"slides":[{"icon":"f2-3-1","color":"turquoise","txt":"f2_slid_txt_1"},{"icon":"f2-3-2","color":"turquoise","txt":"f2_slid_txt_2"},{"icon":"f2-3-3","color":"turquoise","txt":"f2_slid_txt_3"},{"icon":"f2-3-4","color":"turquoise","txt":"f2_slid_txt_4"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/fact2_b_s.json
// module id = cV9r
// module chunks = 1